/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForServiceNowBasicAuthProtocol extends models.ServiceAccountCredentialsBaseForServiceNow {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForServiceNowBasicAuthProtocol");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForServiceNowBasicAuthProtocol.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForServiceNowBasicAuthProtocol>): ServiceAccountCredentialsForServiceNowBasicAuthProtocol {
        let obj = Object.assign(new ServiceAccountCredentialsForServiceNowBasicAuthProtocol(), model);
        ServiceAccountCredentialsForServiceNowBasicAuthProtocol.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForServiceNowBasicAuthProtocol>): ServiceAccountCredentialsForServiceNowBasicAuthProtocol {
        if (!model) return null;
        return ServiceAccountCredentialsForServiceNowBasicAuthProtocol.newInstance(<ServiceAccountCredentialsForServiceNowBasicAuthProtocol> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForServiceNowBasicAuthProtocol) {
        if (!obj) return;

        models.ServiceAccountCredentialsForServiceNowBasicAuthProtocol.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForServiceNowBasicAuthProtocol): boolean {
        if (models.ServiceAccountCredentialsBaseForServiceNow.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForServiceNowBasicAuthProtocol.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Username. This is a required field.
     */
    username: string;

    /**
     * Password. This is a required field.
     */
    password: string;

}
